export default "__VITE_ASSET__C6ZR1lnK__"